import * as React from 'react';
import { ButtonStyle } from '../components/Button';
import Loader from '../components/Loader';
import Page from '../components/Page';
import CompanyAppPreview from '../components/CompanyAppPreview';
import CompanyInSituAppPreview from '../components/CompanyInSituAppPreview';
import { ActionBar, ActionBarStyle } from '../components/ActionBar';
import BasicDetails from './edit-company/BasicDetails';
import CompanyLocation from './edit-company/CompanyLocation';
import CompanyAppearance from './edit-company/CompanyAppearance';
import { ProfileContext } from '../profile';
import { useRequestAsync, getHeaders } from '../api/client';
import Flash, { ErrorFlash } from '../components/Flash';
import { Link, Redirect } from 'react-router-dom';

type CompanyParams = {
  name: string;
  description_text: string;
  image_url: string;
};

const JumpLink = (props: any) => (
  <button
    type="button"
    className={`f5 link dim pv3 pa0 db black bn bg-transparent outline-0 tl ${
      props.current === props.href ? 'b' : 'normal'
    }`}
    onClick={() => props.onClick(props.href)}
  >
    {props.children}
  </button>
);

export default () => {
  const context = React.useContext(ProfileContext);
  const { profile } = context;

  if (!profile.company) {
    return <Redirect to="/company/new" />;
  }

  const [section, setSection] = React.useState('general');
  const [company, setCompany] = React.useState(profile.company);

  const [state, submit] = useRequestAsync((data: CompanyParams) => ({
    url: `/companies/${profile.company_id}`,
    method: 'PUT',
    body: JSON.stringify(data),
    headers: getHeaders(context),
  }));

  React.useEffect(() => {
    if (!state.data) {
      return;
    }

    context.set({
      ...profile,
      company: state.data,
    });
  }, [state]);

  if (state.loading) {
    return <Loader />;
  }

  return (
    <Page
      title="Edit Company"
      subtitle="Customize the look and feel of your coffee brand"
    >
      {state.error && <ErrorFlash error={state.error} />}
      {state.complete && <Flash text="Profile has been saved" />}
      <div className="flex justify-between flex-column flex-row-l">
        <div className="w-20-l flex flex-column">
          <Link to="/dashboard" className="f5 link dim pv3 b black">
            ← Back to Dashboard
          </Link>
          <JumpLink onClick={setSection} href="general" current={section}>
            General
          </JumpLink>
          <JumpLink onClick={setSection} href="location" current={section}>
            Location
          </JumpLink>
          <JumpLink onClick={setSection} href="appearance" current={section}>
            Appearance
          </JumpLink>
        </div>
        <div className="w-80-l flex-auto">
          {section === 'general' && (
            <BasicDetails company={company} onChange={setCompany} />
          )}
          {section === 'location' && (
            <CompanyLocation company={company} onChange={setCompany} />
          )}
          {section === 'appearance' && (
            <CompanyAppearance company={company} onChange={setCompany}>
              <h4 className="f6 db mb2 ttu tc fw3 black-80">
                IN-APP PREVIEW <span className="dn-l">(SCROLL FOR MORE)</span>
              </h4>
              <div className="flex justify-center-l overflow-scroll">
                <div className="mr3">
                  <CompanyAppPreview company={company} />
                </div>
                <div>
                  <CompanyInSituAppPreview company={company} />
                </div>
              </div>
            </CompanyAppearance>
          )}
        </div>
      </div>
      <ActionBar
        className={ActionBarStyle.alignCenter}
        actions={[
          {
            className: ButtonStyle.Confirm,
            label: 'Save',
            handler: () => submit(company),
          },
        ]}
      />
    </Page>
  );
};
